import styles from "./NewsSingle.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
const NewsSingle = () => {
  const { news_id } = useParams();
  console.log(news_id);
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [lines, setLines] = useState([]);
  const [news, setNews] = useState(false);
  useEffect(() => {
    axios
      .post(backend_base + "/home/news", {
        news_id: news_id,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Latest 2 news");
          console.log(res.data);
          setNews(true);
          setTitle(res.data.title);
          setImage(backend_base + res.data.image);
          const newsTextArr = res.data?.text?.split("\n");
          console.log(newsTextArr);
          setLines(newsTextArr);
        } else {
          console.log("Failed Getting news");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [news_id]);
  return (
    <>
      <Header />
      <div className={styles.main_div}>
        {news && (
          <div className={styles.news_div_main}>
            <div className={styles.news_header}>{title}</div>
            <img src={image} alt="news" className={styles.image_main} />
            <div className={styles.lines_main}>
              {lines.length > 0 &&
                lines.map((line) => (
                  <div className={styles.single_line}>{line}</div>
                ))}
            </div>
          </div>
        )}
        <div
          onClick={() => {
            navigate("/onlineshop");
          }}
          className={styles.bottom_button}
        >
          オンラインショップへ
        </div>
      </div>
      <Footer />
    </>
  );
};
export default NewsSingle;
